import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        summary: '',
        months: '',
        pdfDownload: ''
    },
    summary: [],
    months: [],
    selectedYear: null
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
